<template>
  <b-form-group class="choice-buttons">
    <span v-if="label" class="mr-3">
      {{ label }}
    </span>

    <template v-for="item in choices">
      <b-button :key="`select-item-${item.value}`"
                :pressed="internalValue === item.value"
                :disabled="disabled"
                @click="handleItemClick(item)"
                variant="primary"
                size="sm"
                class="choice-button">
        {{ item.text }}
      </b-button>
    </template>
  </b-form-group>
</template>

<script>
export default {
  name: 'buttons-select',

  props: {
    label: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    choices: {
      type: Array,
      default: () => [
        {value: 'empty', text: 'Empty'},
      ],
    },

    value: {
      default: null,
    },
  },

  data() {
    return {
      internalValue: this.value,
    };
  },

  methods: {
    handleItemClick(item) {
      this.internalValue = item.value;
      this.$emit('input', this.internalValue);
    },
  },
}
</script>
